<template>
  <el-col class="data-section">
    <div class="header">
      <div class="info">
        <el-input
          size="mini"
          v-model="data.group_name"
          v-if="editSection"
          @change="editSection = false"
          :key="data.group_order"
        />
        <template v-else>
          {{ data.group_name }}
          <el-button
            icon="el-icon-edit-outline"
            @click="editSection = true"
            circle
            size="mini"
          />
        </template>
      </div>
      <div class="actions">
        <el-button icon="el-icon-d-caret" circle size="mini" />
        <el-button
          icon="el-icon-delete"
          @click="deleteSection()"
          circle
          size="mini"
        />
      </div>
    </div>

    <draggable-table>
      <el-table
        class="table"
        :data="data.attributes"
        stripe
        style="width: 100%"
      >
        <el-table-column label="Attribute">
          <template slot-scope="scope">
            {{ scope.row }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Profiles_Overview_Label_Reorder')"
          width="100"
          align="center"
        >
          <i class="el-icon-d-caret"></i>
        </el-table-column>
        <el-table-column
          :label="$t('Profiles_Overview_Label_Remove')"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <i class="el-icon-delete" @click="deleteAttr(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </draggable-table>

    <div class="table-footer">
      <el-popover width="256" trigger="click">
        <el-select
          @visible-change="fetchAttributes(null)"
          @change="addAttr"
          v-model="newAttr"
          size="mini"
          filterable
          reserve-keyword
          :placeholder="$t('Profiles_Overview_Text_SelectAttribute')"
          remote
          :remote-method="fetchAttributes"
        >
          <el-option
            v-for="(item, index) in attributes.filter(
              opt => !data.attributes.includes(opt.name)
            )"
            :key="index"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
        <el-button
          slot="reference"
          icon="el-icon-circle-plus-outline"
          type="primary"
        >
          {{ $t('Profiles_Overview_Text_AddAttribute') }}
        </el-button>
      </el-popover>
    </div>
  </el-col>
</template>

<script>
import DraggableTable from '@/common/components/table/DraggableTable'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'FeaturedAttributesSection',

  components: { DraggableTable },

  data() {
    return {
      newAttr: null,
      editSection: false,
      attributes: []
    }
  },

  props: {
    data: {
      type: Object,
      default: {}
    }
  },

  computed: {
    fetchAttributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tags`
      })
    }
  },

  methods: {
    deleteSection() {
      this.$emit('delete-section')
    },

    deleteAttr(row) {
      this.$emit('delete-attr', row)
    },

    addAttr(attr) {
      this.$emit('add-attr', attr)
      this.newAttr = null
    },

    fetchAttributes(query) {
      RestApi({
        ...this.fetchAttributesEndpoint,
        params: query !== null && query !== '' ? { title: query } : null
      })
        .then(({ data }) => {
          this.attributes = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.data-section {
  margin: 8px 0;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #dbdee7;
  border-radius: 4px;
  .header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
  }
  &.add-section {
    text-align: center;
  }
  .table-footer {
    padding: 10px;
    background-color: #ffffff;
    border: 1px solid #dbdee7;
    border-top: none;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}
/deep/ .el-table {
  box-shadow: inset 0px -1px 0px #ebeef5;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border: 1px solid #dbdee7;
  border-bottom: none;
  .el-table__row {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/FeaturedAttributesSection.vue